<template>
  <div class="page-wrapper">
    <PageHeader />
    <div class="form-page-wrap">
      <div class="form-card">
        <h2>修改密码</h2>
        <div class="form-group">
          <label>手机号</label>
          <input class="form-control" type="text" v-model="mobile" placeholder="请输入绑定手机号" maxlength="11" />
        </div>
        <div class="form-group">
          <label>验证码</label>
          <div class="form-code-row">
            <input class="form-control" type="text" v-model="code" placeholder="请输入验证码" maxlength="6" />
            <button class="code-btn" @click="sendCode" :disabled="countdown > 0">
              {{ countdown > 0 ? countdown + 's后重发' : '发送验证码' }}
            </button>
          </div>
        </div>
        <div class="form-group">
          <label>新密码</label>
          <input class="form-control" type="password" v-model="newPassword" placeholder="请设置新密码（6-20位）" />
        </div>
        <div class="form-group">
          <label>确认新密码</label>
          <input class="form-control" type="password" v-model="confirmPassword" placeholder="请再次输入新密码" />
        </div>
        <button class="form-btn" @click="handleSubmit">确认修改</button>
        <div class="form-links">
          <router-link class="form-link" to="/login">返回登录</router-link>
        </div>
      </div>
    </div>
    <PageFooter />
  </div>
</template>

<script>
import PageHeader from '@/views/detail/components/PageHeader.vue'
import PageFooter from '@/views/detail/components/PageFooter.vue'

export default {
  name: 'ResetPassword',
  components: { PageHeader, PageFooter },
  data() {
    return {
      mobile: '',
      code: '',
      newPassword: '',
      confirmPassword: '',
      countdown: 0,
      timer: null
    }
  },
  methods: {
    sendCode() {
      if (!this.mobile || !/^1[3-9]\d{9}$/.test(this.mobile)) {
        alert('请输入正确的手机号')
        return
      }
      this.countdown = 60
      this.timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) clearInterval(this.timer)
      }, 1000)
    },
    handleSubmit() {
      if (!this.mobile || !this.code || !this.newPassword || !this.confirmPassword) {
        alert('请填写完整信息')
        return
      }
      if (this.newPassword !== this.confirmPassword) {
        alert('两次密码输入不一致')
        return
      }
      alert('密码修改成功！')
      this.$router.push('/login')
    }
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  }
}
</script>

<style scoped>
@import './form.css';
.page-wrapper { display: flex; flex-direction: column; min-height: 100vh; }
.form-page-wrap { flex: 1; }
</style>
